import PendingRegistrations from "./PendingRegistrations";

export default PendingRegistrations;
